// extracted by mini-css-extract-plugin
export default {"folderFilterControl":"FolderFilterControl_folderFilterControl__V5rBf","label":"FolderFilterControl_label__5Be5M"};